import script from "./EventSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./EventSetup.vue?vue&type=script&setup=true&lang=js"

import "./EventSetup.vue?vue&type=style&index=0&id=6e5e980a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e5e980a"]])

export default __exports__